export function profileURL(masDealerCode, locale) {
  return `${
    locale ? `/${locale?.toLowerCase() || 'en-us'}` : ''
  }/roofing/contractors/contractor-profile/${masDealerCode}`;
}
